<div class="header-bar-wrapper">
  <div class="header-bar" [class.ghost]="job == null">
    <div class="flex flex-wrap grid-gap-10 w-100">
      <div
        class="flex-grow-1 flex grid-gap-10 align-items-center"
        [ngClass]="{ 'mt-2': job?.supplierId && !routeInboxEnabled }"
      >
        <div class="flex-shrink-1 white-space-nowrap cursor-pointer" (click)="goBack()">
          <i class="fa fa-angle-left"></i> Back
        </div>

        <div class="flex-shrink-1 ghost-inline job-number white-space-nowrap">
          {{ job?.jobNumber }}:
          {{
            (job?.supplierId ? job?.supplierPrice : job?.buyItNowPrice)
              | currency : 'GBP' : 'symbol' : '1.2-2'
          }}
        </div>
        <div
          class="flex-shrink-1 ghost-inline status-chip white-space-nowrap"
          [class]="'status-chip-' + commonService.getStatusCode(job)"
        >
          {{ commonService.getStatus(job) }}
        </div>
      </div>
      <div class="flex-shrink-1" *ngIf="routeInboxEnabled">
        <div class="flex align-items-center grid-gap-5 flex-wrap">
          <button
            class="pull-right ui-button ui-button-secondary"
            type="button"
            [label]="'Routes Inbox (in ' + routesContainingJobCount + ' routes)'"
            pButton
            [disabled]="routesContainingJobCount == 0"
            (click)="loadRoutesInbox()"
          ></button>
        </div>
      </div>
      <div class="flex-shrink-1" *ngIf="!job?.supplierId">
        <div class="flex align-items-center grid-gap-5 flex-wrap">
          <button
            class="pull-right ui-button ui-button-secondary"
            type="button"
            [label]="job?.hidden ? 'Job Hidden' : 'Hide'"
            pButton
            (click)="rejectJob()"
            [disabled]="job?.hidden"
          ></button>
          <button
            class="pull-right ui-button ui-button-secondary"
            type="button"
            label="Watch"
            pButton
            (click)="watchJob()"
            *ngIf="!job?.watched"
          ></button>
          <button
            class="pull-right ui-button ui-button-secondary"
            type="button"
            label="Remove from Watched"
            pButton
            (click)="unwatchJob()"
            *ngIf="job?.watched"
          ></button>
        </div>
      </div>
      <div class="flex-shrink-1" *ngIf="job?.supplierId">
        <div class="flex align-items-center grid-gap-5 flex-wrap">
          <button
            class="pull-right"
            type="button"
            label="Price Details"
            pButton
            *ngIf="commonService.canShowPriceDetails(job)"
            (click)="commonService.goToPriceDetails(organisationTypeId, job)"
          ></button>
        </div>
      </div>
    </div>
  </div>
  <app-tab-scroller [tabs]="tabs" (tabSelected)="onTabSelected($event)"></app-tab-scroller>
</div>

<div [hidden]="activeViewId !== 'scroll'">
  <div class="content-container mt-3 pt-2 scroll-id job-screen-container mt-3" id="jobOverview">
    <h2 class="sub-header-bar">Job Overview</h2>
    <div>
      <supplier-job-screen-job-tasks
        [jobId]="jobId"
        [organisationId]="organisationId"
      ></supplier-job-screen-job-tasks>
    </div>
  </div>

  <div
    class="content-container mt-3 pt-2 scroll-id job-screen-container"
    *ngIf="job?.supplierId"
    id="jobDetails"
  >
    <h2 class="sub-header-bar">Job Details</h2>

    <div class="flex flex-wrap grid-gap-15 mb-3">
      <div style="flex: 1; min-width: 200px">
        <supplier-job-screen-supplier-info [jobId]="jobId"></supplier-job-screen-supplier-info>
      </div>

      <div style="flex: 1; min-width: 200px">
        <job-screen-carry-over
          [jobId]="jobId"
          [organisationId]="organisationId"
          [organisationTypeId]="organisationTypeId"
        ></job-screen-carry-over>
      </div>
    </div>

    <div class="w-100">
      <app-job-screen-history
        [jobId]="jobId"
        [panelHeight]="'350px'"
        [organisationId]="organisationId"
        [organisationTypeId]="organisationTypeId"
      ></app-job-screen-history>
    </div>

    <div class="mt-3">
      <supplier-job-screen-additional-costs [jobId]="jobId"></supplier-job-screen-additional-costs>
    </div>
  </div>

  <div class="content-container mt-3 pt-2 scroll-id job-screen-container" id="taskDetails">
    <h2 class="sub-header-bar">Task Details</h2>
    <div>
      <supplier-job-screen-tasks
        [organisationId]="organisationId"
        [jobId]="jobId"
        [supplierPremiums]="job?.supplierPremiums"
        *ngIf="job"
      ></supplier-job-screen-tasks>
    </div>
  </div>
</div>

<div *ngIf="activeViewId === 'routeItinerary' && job?.routeRecommendationId">
  <route-recommendation-detailed-view
    [routeRecommendationId]="job?.routeRecommendationId"
  ></route-recommendation-detailed-view>
</div>

<supplier-job-screen-reject-job
  *ngIf="job"
  [job]="job"
  [(rejectJobDialogVisible)]="rejectJobVisible"
></supplier-job-screen-reject-job>
